import { apiClient } from '@/platform/api/services/client';

import type {
  TeamSettingsResponse,
  CreateTeamSettingsRequest,
  UpdateTeamSettingsRequest,
} from '@/shared/domain/teamTypes';

export async function getTeamSettings(teamId: string): Promise<TeamSettingsResponse> {
  const { data } = await apiClient.get(`/api/v1/teams/${teamId}/settings`);
  return data;
}

export async function createTeamSettings(
  teamId: string,
  settingsData: CreateTeamSettingsRequest
): Promise<TeamSettingsResponse> {
  const { data } = await apiClient.post(`/api/v1/teams/${teamId}/settings`, settingsData);
  return data;
}

export async function updateTeamSettings(
  teamId: string,
  settingsData: UpdateTeamSettingsRequest
): Promise<TeamSettingsResponse> {
  const { data } = await apiClient.put(`/api/v1/teams/${teamId}/settings`, settingsData);
  return data;
}

export async function deleteTeamSettings(teamId: string): Promise<void> {
  await apiClient.delete(`/api/v1/teams/${teamId}/settings`);
}
